import { useMutation, UseMutationResult } from '@tanstack/react-query'
import { gql } from 'graphql-request'

import { useGraphQLClient } from '@/hooks/useGraphQLClient'

const PARTIAL_USER_MUTATION = gql`
  mutation ($input: CreatePartialUserInput!) {
    createPartialUser(input: $input) {
      user {
        id
        name
        email
        phoneNumber
        countryCode
      }
      success
      errors {
        field
        message
      }
    }
  }
`

export interface PartialUserCreateInput {
  firstName?: string
  lastName?: string
  email?: string
  phoneNumber?: string
  countryCode?: string
  hearAboutUs?: string
  otherHearAboutUs?: string
}

interface CreatePartialUserMutation {
  user: User
  success: boolean
  errors: MutationError[]
}

interface UpdateUserMutationResponse {
  createPartialUser: CreatePartialUserMutation
}

export const usePartialUserCreateApi = (): UseMutationResult<
  CreatePartialUserMutation,
  Error,
  PartialUserCreateInput,
  unknown
> => {
  const client = useGraphQLClient()

  const partialUserCreateApi = async (
    input: PartialUserCreateInput,
  ): Promise<CreatePartialUserMutation> => {
    const result = await client.request<UpdateUserMutationResponse>(PARTIAL_USER_MUTATION, {
      input,
    })

    return result.createPartialUser
  }

  return useMutation<CreatePartialUserMutation, Error, PartialUserCreateInput>({
    mutationFn: partialUserCreateApi,
  })
}
